import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import ChatInterface from "./features/chat/components/ChatInterface";
import ChannelManagementClient from "./features/channel/components/ChannelManagementClient";
import UserSelector from "./features/auth/UserSelector";
import SignInPage from "./features/auth/SignInPage";
import ImageLightbox from "./components/ui/ImageLightbox";
import { useAuth } from "./context/AuthContext";
import { useChat } from "./context/ChatContext";
import { useServiceWorkerUpdate } from "./hooks/useServiceWorkerUpdate";
import { useAppBadge } from "./hooks/useAppBadge";

import "./index.css";
import "./components/toastStyles.css";

const AppContent = () => {
  const { user, setUser } = useAuth();
  const { totalUnread } = useChat();

  // Show an "update available — Reload" prompt when a new build is deployed.
  useServiceWorkerUpdate();

  // Mirror the collective unread count onto the PWA app-icon badge.
  useAppBadge(totalUnread);

  const handleUserSelected = (selectedUser) => {
    setUser(selectedUser);
  };

  // Not authenticated → show the in-app login (instead of redirecting to portal).
  // AuthProvider only renders children once the auth check has finished, so
  // reaching here with no user means the session is genuinely absent.
  if (!user) {
    return <SignInPage />;
  }

  return (
    <>
      <div className="min-h-screen bg-[var(--bg-darker)] text-[var(--text-main)] transition-colors duration-500">
        <Routes>
          <Route path="/chat-interface" element={<ChatInterface />} />
          <Route path="/channel/:id" element={<ChatInterface />} />
          <Route path="/dm/:id" element={<ChatInterface />} />
          <Route
            path="/channel-management"
            element={<ChannelManagementClient />}
          />
          <Route path="/" element={<Navigate to="/chat-interface" replace />} />
          <Route path="*" element={<Navigate to="/chat-interface" replace />} />
        </Routes>
      </div>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
      <ImageLightbox />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#ffffff",
            color: "#1a1a19",
            border: "1px solid rgba(23,23,22,0.12)",
            borderRadius: "0px",
            fontFamily: "inherit",
          },
          success: {
            iconTheme: {
              primary: "#10b981",
              secondary: "white",
            },
            duration: 3000,
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "white",
            },
            duration: 3000,
          },
        }}
      />
    </Router>
  );
};

export default App;
